import React, { FunctionComponent } from "react"
import { Button, Modal } from "react-bootstrap"

interface Props {
    text: string
    manageParentState: Function
}

const FileNameError: FunctionComponent<Props> = (props) => {//bump

    const { text, manageParentState } = props



    return (
        <div className="FileNameError">
            <Modal id={"b594112e40fa8ffc171030b1a15b"}
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="sm"
            >
                <Modal.Header>
                    <div className="FileNameErrorModalHeader">
                        <div className="FileNameErrorModalHeaderEmoji">
                            {`(>_<)`}
                        </div>
                        <div className="FileNameErrorModalHeaderText">
                            <p>The following file name is too long...(50 character max)</p>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="FileNameErrorModalBody">
                        <div className="FileNameErrorModalBodyText">
                            {text}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="FileNameErrorModalFooter">
                        <Button onClick={() => manageParentState([{ key: "fileNameError", value: { err: false, fileName: "" } }])
                        }>OK</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default FileNameError